// Matches `routing-helper.js` DEFAULT_ALLOTTED_TIME, so arrival times web derives from
// stored leg metrics match the ones a preview would have returned.
export const DEFAULT_ALLOTTED_TIME_SECONDS = 30 * 60; // 30 min
